import { Roles } from '@common/types/user';

const INVALID_PASSWORD_ERROR_REGEX = /^(password).*(hash).*(not valid)[.]{1}$/gi;

const PASSWORD_REQUIREMENTS_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}\[\]|:;"'<>,.?/~`])/;

const ROLE_HIERARCHY = [
    Roles.VICTRON,
    Roles.SALES_DIRECTOR,
    Roles.SALES_MANAGER,
    Roles.DISTRIBUTOR,
    Roles.AMBASSADOR,
    Roles.DEALER,
    Roles.INSTALLER,
    Roles.AUTHORIZED_INSTALLER,
    Roles.END_USER,
    Roles.UNREGISTERED,
];

export { INVALID_PASSWORD_ERROR_REGEX, PASSWORD_REQUIREMENTS_REGEX, ROLE_HIERARCHY };
